<template>
  <div
    v-expose-track="{
      seckillNew: {
        mapId: 'seckillGood',
        data: {
          good,
          sku_pos: index,
          discount_attribute: isPromote ? '1' : '0'
        }
      }
    }"
    class="good-card"
    @click.prevent="handleChoose(good, index)"
  >
    <div
      class="good-card-img"
      :style="{
        opacity: good.soldout ? '0.6' : '1'
      }"
    >
      <span v-if="good.soldout" class="soldout">{{
        good.SRI.status_show_name
      }}</span>
      <img
        :src="good.img_url | ossImage(500, 500, 'contain')"
        @error="imgLoadFail"
      />
      <!-- 抢购进度条(只有进行中展示，其他情况空白占位) -->
      <div
        :class="[
          'progress',
          !isPromote && activeTab.status === 1 && !good.hasParticipate
            ? ''
            : 'hidden'
        ]"
      >
        <span>{{
          good.SRI.remain_count
            ? `仅剩${good.SRI.remain_count}件`
            : good.SRI.status_show_name
        }}</span>
        <a
          :style="{
            width:
              (good.SRI.remain_count / good.SRI.promote_amount_limit_origin) *
                100 +
              '%'
          }"
        ></a>
      </div>
    </div>
    <div class="good-card-desc">
      <div class="main-title">{{ good.name }}</div>
      <!-- 价格与加购区域 -->
      <div class="price-operator-wrap">
        <!-- 原价与划线价格信息 -->
        <div class="price-area">
          <!-- 总价 -->
          <div
            v-if="!isPromote && good.total_price_with_fp"
            class="total-price"
          >
            ￥{{ good.total_price_with_fp }}
          </div>
          <template v-if="isPromote">
            <div class="promote-price-bg">
              <div class="cut">
                <img src="@/images/seckill/arrow.png" />
                <span>降价¥{{ good.diffPrice }}</span>
              </div>
              <span
                v-if="
                  unitPriceFormat.originPrice &&
                  Number(unitPriceFormat.originPrice) > 0
                "
                class="underline-price"
                >￥{{ unitPriceFormat.originPrice }}</span
              >
            </div>
            <div class="promote-price-wrapper">
              <div class="promote-price">
                <span class="prefix">{{ unitPriceFormat.prefix }}</span>
                <span class="price">{{ unitPriceFormat.price }}</span>
                <span class="unit">/{{ unitPriceFormat.unit }}</span>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="seckill-price-bg">立省<br />￥{{ good.diffPrice }}</div>
            <div class="seckill-price">
              <span class="prefix">{{ unitPriceFormat.prefix }}</span>
              <span class="price">{{ unitPriceFormat.price }}</span>
              <span class="unit">/{{ unitPriceFormat.unit }}</span>
              <span
                v-if="
                  unitPriceFormat.originPrice &&
                  Number(unitPriceFormat.originPrice) > 0
                "
                class="underline-price"
                >￥{{ unitPriceFormat.originPrice }}</span
              >
            </div>
          </template>
        </div>
        <!-- 加购按钮 -->
        <div v-if="!good.soldout" class="good-card-operator">
          <new-operator
            use-new-activity
            show-simple-count
            :ssu="good"
            :activity-info="activeTab"
            :is-promote="isPromote"
            @add="
              e => {
                handleAdd(e, index)
              }
            "
            @goDetail="goDetail"
          />
        </div>
        <!-- 已抢光展示‘去看看’按钮 -->
        <div v-else-if="good.SRI.goods_status === 7" class="good-card-guide">
          <span class="guide-text">去看看</span>
          <IconFont name="arrow_right_m" color="#fff" size="10px" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { redirect } from '@/utils/native_interactions/native_redirect'
import { imgLoadFail } from '@/utils/oss_image'
import { nativeRoutes } from '@/utils/native_interactions/native_redirect/routes'

import NewOperator from '@/common/widgets/newOperator'
export default {
  components: {
    // Operator,
    NewOperator
  },
  props: {
    good: {
      type: Object,
      default: () => {}
    },
    activeTab: {
      type: Object,
      default: () => {}
    },
    index: {
      type: Number,
      default: 0
    },
    isPromote: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    unitPriceFormat() {
      if (this.isPromote) {
        return {
          prefix: '￥',
          price: this.good.total_price,
          unit: this.good.ssu_fp_text,
          originPrice: this.good.original_price
        }
      }
      // 是否展示约等于逻辑处理
      const approximateShow = this.good.is_show_weight_unit_price === 1

      // 原价逻辑
      // 如果有约等于，则当划线价不等于原单价时展示
      // 否则按照无约等于时的划线价展示
      let originPrice = ''
      if (approximateShow) {
        originPrice =
          this.good.weight_original_unit_price !== this.good.weight_unit_price
            ? this.good.weight_original_unit_price
            : ''
      } else {
        originPrice = this.good.original_unit_price
      }

      return {
        prefix: approximateShow ? '约￥' : '￥',
        price: this.good[approximateShow ? 'weight_unit_price' : 'unit_price'],
        unit: this.good[approximateShow ? 'weight_price_unit' : 'price_unit'],
        originPrice
      }
    }
  },
  methods: {
    imgLoadFail,
    handleChoose(good, index) {
      // 埋点
      this.$track(`n.820.2081.${good.ssu_id}`, {
        ssu_id: good.ssu_id,
        sku_id: good.sku_id,
        sku_pos: index,
        activity_id: good.activity_id ? good.activity_id + '' : '',
        discount_attribute: this.isPromote ? '1' : '0',
        price: good?.priceSpm || ''
      })
      if (
        Number(good.status_remind_info.goods_status) === 4 ||
        Number(good.status_remind_info.goods_status) === 5
      ) {
        this.$toast({
          message: good.status_remind_info.no_buy_time_remind
        })
        // eslint-disable-next-line camelcase
      } else {
        redirect({
          nativeRoute: nativeRoutes.goodsDetail,
          queries: {
            tickReferId: `n.820.2081.${good.ssu_id}.${index}` // tickReferId = spm + skuIndex
          },
          ssuIdFromH5: good.ssu_id
        })
      }
    },
    handleAdd(ssu, index) {
      // eslint-disable-next-line camelcase
      const { ssu_id, sku_id, activity_id } = ssu
      // eslint-disable-next-line camelcase
      this.$track(`n.820.2041.${ssu_id}`, {
        ssu_id,
        sku_id,
        // eslint-disable-next-line camelcase
        activity_id: activity_id ? activity_id + '' : '',
        sku_pos: index,
        discount_attribute: this.isPromote ? '1' : '0',
        price: ssu?.priceSpm || ''
      })
    },
    goDetail() {
      redirect({
        nativeRoute: nativeRoutes.goodsDetail,
        queries: {
          tickReferId: `n.820.2081.${this.good.ssu_id}.${this.index}` // tickReferId = spm + skuIndex
        },
        ssuIdFromH5: this.good.ssu_id
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.good-card {
  position: relative;

  width: 7rem;
  margin: 0 auto 0.18rem;
  padding: 0.16rem;

  background-color: #fff;
  border-radius: 0.16rem;
  @include flex(row, flex-start, flex-start, nowrap);
  &-img {
    position: relative;

    width: 1.6rem;
    height: 1.6rem;
    margin: 0 0.2rem 0 0;

    flex: none;
    img {
      width: 100%;
      height: 100%;

      border-radius: 0.16rem;
      object-fit: contain;
    }

    .soldout {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);

      width: 1.2rem;
      height: 0.48rem;

      background-color: rgba(0, 0, 0, 0.5);
      border-radius: 0.04rem;

      font-size: 0.24rem;
      color: #fff;
      @include flex-row-center;
    }
    .progress {
      position: absolute;
      right: 0.04rem;
      bottom: 0.06rem;
      left: 0.04rem;

      height: 0.24rem;
      padding-left: 0.2rem;
      overflow: hidden;

      background-color: #f8c8bb;
      border-radius: 0.24rem;

      font-size: 0.2rem;
      line-height: 0.24rem;
      text-align: left;
      color: #fff;
      &.hidden {
        display: none;
      }
      span {
        display: inline-block;

        position: absolute;

        z-index: 2;
        transform: scale(0.5);

        width: 200%;
        height: 0.48rem;

        font-size: 0.4rem;
        line-height: 0.48rem;
        text-align: left;
        color: #fff;
        transform-origin: 0 0;
      }
      a {
        display: block;

        position: absolute;
        top: 0;
        left: 0;

        width: 0;
        height: 100%;

        background-image: linear-gradient(to right, #f65d2a, #fe2a42);
        border-radius: 0.3rem;

        content: '';
      }
    }
  }

  &-desc {
    width: 0;

    flex: auto;
    .main-title {
      font-size: 0.3rem;
      line-height: 0.42rem;
      font-weight: bold;
      color: #262626;

      @include text-overflow-ellipsis-single;
    }

    .price-operator-wrap {
      display: flex;

      flex-direction: row;
      align-items: center;

      .price-area {
        flex: auto;

        .total-price {
          margin-top: 0.04rem;

          font-size: 0.24rem;
          line-height: 0.34rem;
          color: #8c8c8c;
        }

        .seckill-price-bg {
          width: 3rem;
          height: 0.8rem;
          margin-top: 0.08rem;
          padding-top: 0.04rem;

          background-image: url('~@/images/seckill/seckill_bg.png');

          background-repeat: no-repeat;

          font-size: 0.2rem;
          line-height: 0.24rem;
          text-align: center;
          color: #fff;
          background-size: contain;
        }

        .promote-price-bg {
          position: relative;

          width: 3.08rem;
          height: 0.6rem;
          margin-top: 0.06rem;

          background-image: url('~@/images/seckill/promote_bg.png');

          background-repeat: no-repeat;
          background-size: contain;
          .underline-price {
            position: absolute;
            top: 0.18rem;
            left: 0.18rem;

            font-size: 0.24rem;
            text-decoration: line-through;
            color: #999;
          }
          .cut {
            display: flex;

            position: absolute;
            top: 0;
            right: 0;

            width: 1.6rem;
            height: 0.32rem;

            background-color: #ffeded;
            border-radius: 0.4rem;

            flex-direction: row;
            justify-content: center;
            align-items: center;

            font-size: 0.24rem;
            color: #f03100;
            &:after {
              display: block;

              position: absolute;
              bottom: -8px;
              left: 50%;
              transform: translateX(-50%);

              border: 4px solid transparent;
              border-top: 4px solid #ffeded;

              content: '';
            }

            & > img {
              width: 0.22rem;
              height: 0.22rem;
            }
          }
        }
        .promote-price-wrapper {
          position: relative;

          height: 0.36rem;
          margin-top: 0.1rem;
        }
        .promote-price {
          position: absolute;
          right: 29%;
          transform: translateX(50%);

          color: #f03100;
          .prefix {
            font-size: 0.24rem;
          }
          .price {
            font-size: 0.36rem;
            font-weight: 500;
          }
          .unit {
            font-size: 0.24rem;
          }
        }

        .seckill-price {
          position: relative;

          padding-right: 0.3rem;

          text-align: center;
          color: #f03100;
          .prefix {
            font-size: 0.26rem;
          }
          .price {
            font-size: 0.44rem;
            font-weight: 500;
          }
          .unit {
            font-size: 0.26rem;
          }
          .underline-price {
            position: absolute;
            top: 0.16rem;
            right: 0.1rem;

            font-size: 0.24rem;
            text-decoration: line-through;
            color: #8c8c8c;
          }
        }
      }
    }
  }

  &-guide {
    display: flex;

    position: relative;

    width: 1.6rem;
    height: 0.8rem;

    background-color: #bfbfbf;

    border-radius: 0.16rem;

    flex-direction: row;
    justify-content: center;
    align-items: center;
    .guide-text {
      margin-right: 0.02rem;

      font-size: 0.24rem;
      color: #fff;
    }
  }
}
</style>
